<div class="search-page">
  <mat-sidenav-container class="search-page__container">
    <mat-sidenav class="search-page__sidebar" mode="side" [opened]="sidebarOpened" (openedChange)="onSidebarOpenedChange()">
      <div class="search-page__header">
        <app-search-form #form class="search__form" [query]="query" [activityState]="activityState"
                         (queryChanged)="search()" (locationStateChanged)="onLocationStateChanged($event)"
                         (error)="onError($event)">
        </app-search-form>
        <a href="#" (click)="onClickNewSearch($event)" mat-button type="button" class="search-page__new-search-btn">
          <mat-icon>search</mat-icon>
          <span class="search-page__new-search-text">New Search</span>
        </a>
      </div>
      <mat-tab-group #tabGroup disableRipple="true" [@.disabled]="true" (selectedTabChange)="onSelectTab($event)">
        <mat-tab #airportsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">airplanemode_active</mat-icon>
              <span class="search-page__tab-text">Airports</span>
            </div>
          </ng-template>
          <app-airport-results-listing
            #airportResultsListing class="search-page__results" [query]="query"
            [state]="airportState" [airports]="pagedAirports" [activeAirport]="activeAirport"
            [pageIndex]="pageIndex" [pageSize]="pageSize" [totalAirports]="filteredAirports.length"
            (filtersChanged)="onFiltersChanged(false)" (publicUseChanged)="onPublicUseChanged()"
            (pageChanged)="onPageChanged($event)"
            (fuelPriceToggleChanged)="onFuelPriceToggleChanged()"
            (airportMouseEnter)="onAirportCardHover($event, true)"
            (airportMouseLeave)="onAirportCardHover($event, false)">
          </app-airport-results-listing>
        </mat-tab>
        <mat-tab #activitiesTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">location_on</mat-icon>
              <span class="search-page__tab-text">Nearby Activities</span>
            </div>
          </ng-template>
          <app-activity-results-listing
            #activityResultsListing class="search-page__results" [query]="query"
            [state]="activityState" [activities]="activities" [activeActivity]="selectedActivity"
            (selectedActivityChange)="onSelectedActivityChange()"
            (activityMouseEnter)="onActivityCardHover($event, true)"
            (activityMouseLeave)="onActivityCardHover($event, false)">
          </app-activity-results-listing>
        </mat-tab>
        <mat-tab #aviationEventsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">event</mat-icon>
              <span class="search-page__tab-text">Events</span>
            </div>
          </ng-template>
          <app-event-results-listing
            #eventsResultsListing class="search-page__results" [query]="query"
            [state]="aviationEventsState" [aviationEvents]="pagedAviationEvents" [activeAviationEvent]="activeAviationEvent"
            [eventPageIndex]="eventPageIndex" [eventPageSize]="eventPageSize"
            [totalAviationEvents]="filteredAviationEvents.length"
            (filtersChanged)="onAviationEventsFiltersChanged()"
            (eventPageChanged)="onEventPageChanged($event)"
            (filtersDateChanged)="onAviationEventsFiltersDateChanged()"
            (eventMouseEnter)="onEventCardHover($event, true)"
            (eventMouseLeave)="onEventCardHover($event, false)"
            (showAirportsToggleChanged)="onShowAirportsToggleChanged()">
          </app-event-results-listing>
        </mat-tab>
        <mat-tab #flyingClubsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">group</mat-icon>
              <span class="search-page__tab-text">Flying Clubs</span>
            </div>
          </ng-template>
          <app-flying-club-finder-results-listing
            #flyingClubFinderResultsListing class="search-page__results" [query]="query"
            [state]="flyingClubsState" [flyingClubs]="pagedFlyingClubs" [activeFlyingClub]="activeFlyingClub"
            [pageIndex]="flyingClubPageIndex" [pageSize]="flyingClubPageSize"
            [totalFlyingClubs]="filteredFlyingClubs.length"
            (filtersChanged)="onFlyingClubFiltersChanged()"
            (pageChanged)="onFlyingClubPageChanged($event)"
            (flyingClubMouseEnter)="onFlyingClubCardHover($event, true)"
            (flyingClubMouseLeave)="onFlyingClubCardHover($event, false)">
          </app-flying-club-finder-results-listing>
        </mat-tab>
        <mat-tab #flightSchoolsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">school</mat-icon>
              <span class="search-page__tab-text">Flight Schools</span>
            </div>
          </ng-template>
          <app-flight-school-finder-results-listing
            #flightSchoolFinderResultsListing class="search-page__results" [query]="query"
            [state]="flightSchoolsState" [flightSchools]="pagedFlightSchools" [activeFlightSchool]="activeFlightSchool"
            [pageIndex]="flightSchoolPageIndex" [pageSize]="flightSchoolPageSize"
            [totalFlightSchools]="filteredFlightSchools.length"
            (filtersChanged)="onFlightSchoolFiltersChanged()"
            (pageChanged)="onFlightSchoolPageChanged($event)"
            (flightSchoolMouseEnter)="onFlightSchoolCardHover($event, true)"
            (flightSchoolMouseLeave)="onFlightSchoolCardHover($event, false)">
          </app-flight-school-finder-results-listing>
        </mat-tab>
        <mat-tab #universitiesTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">account_balance</mat-icon>
              <span class="search-page__tab-text">Universities</span>
            </div>
          </ng-template>
          <app-university-finder-results-listing
            #universityFinderResultsListing class="search-page__results" [query]="query"
            [state]="universitiesState" [universities]="pagedUniversities" [activeUniversity]="activeUniversity"
            [pageIndex]="universityPageIndex" [pageSize]="universityPageSize"
            [totalUniversities]="filteredUniversities.length"
            (filtersChanged)="onUniversityFiltersChanged()"
            (pageChanged)="onUniversityPageChanged($event)"
            (universityMouseEnter)="onUniversityCardHover($event, true)"
            (universityMouseLeave)="onUniversityCardHover($event, false)">
          </app-university-finder-results-listing>
        </mat-tab>
        <mat-tab #fbosTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">local_gas_station</mat-icon>
              <span class="search-page__tab-text">FBOs</span>
            </div>
          </ng-template>
          <app-fbo-finder-results-listing
            #fboFinderResultsListing class="search-page__results" [query]="query"
            [state]="fbosState" [fbos]="pagedFbos" [activeFbo]="activeFbo"
            [pageIndex]="fboPageIndex" [pageSize]="fboPageSize"
            [totalFbos]="filteredFbos.length"
            (filtersChanged)="onFboFiltersChanged()"
            (pageChanged)="onFboPageChanged($event)"
            (fboMouseEnter)="onFboCardHover($event, true)"
            (fboMouseLeave)="onFboCardHover($event, false)">
          </app-fbo-finder-results-listing>
        </mat-tab>
        <mat-tab #serviceRepairsTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">build</mat-icon>
              <span class="search-page__tab-text">Service/Repair</span>
            </div>
          </ng-template>
          <app-service-repair-finder-results-listing
            #serviceRepairFinderResultsListing class="search-page__results" [query]="query"
            [state]="serviceRepairsState" [serviceRepairs]="pagedServiceRepairs" [activeServiceRepair]="activeServiceRepair"
            [pageIndex]="serviceRepairPageIndex" [pageSize]="serviceRepairPageSize"
            [totalServiceRepairs]="filteredServiceRepairs.length"
            (filtersChanged)="onServiceRepairFiltersChanged()"
            (pageChanged)="onServiceRepairPageChanged($event)"
            (serviceRepairMouseEnter)="onServiceRepairCardHover($event, true)"
            (serviceRepairMouseLeave)="onServiceRepairCardHover($event, false)">
          </app-service-repair-finder-results-listing>
        </mat-tab>
        <mat-tab #rentalSalesTab>
          <ng-template mat-tab-label>
            <div class="search-page__tab">
              <mat-icon class="search-page__tab-icon">local_offer</mat-icon>
              <span class="search-page__tab-text">Rentals/Sales</span>
            </div>
          </ng-template>
          <app-rental-sales-finder-results-listing
            #rentalSalesFinderResultsListing class="search-page__results" [query]="query"
            [state]="rentalSalesState" [rentalSales]="pagedRentalSales" [activeRentalSales]="activeRentalSales"
            [pageIndex]="rentalSalesPageIndex" [pageSize]="rentalSalesPageSize"
            [totalRentalSales]="filteredRentalSales.length"
            (filtersChanged)="onRentalSalesFiltersChanged()"
            (pageChanged)="onRentalSalesPageChanged($event)"
            (rentalSalesMouseEnter)="onRentalSalesCardHover($event, true)"
            (rentalSalesMouseLeave)="onRentalSalesCardHover($event, false)">
          </app-rental-sales-finder-results-listing>
        </mat-tab>
      </mat-tab-group>
    </mat-sidenav>
    <mat-sidenav-content>
      <div class="search-page__sidebar-toggle" (click)="toggleSidebar()" [matTooltip]="toggleTooltip"
           matTooltipPosition="right">
        <mat-icon *ngIf="sidebarOpened" class="search-page__sidebar-toggle-icon">chevron_left</mat-icon>
        <mat-icon *ngIf="!sidebarOpened" class="search-page__sidebar-toggle-icon">chevron_right</mat-icon>
      </div>
      <app-results-map #map class="search-page__map"
                       [airports]="declutteredAirports" [activeAirport]="activeAirport" [selectedAirport]="selectedAirport"
                       [activities]="activities" [selectedActivity]="selectedActivity"
                       [aviationEvents]="filteredAviationEvents" [activeAviationEvent]="activeAviationEvent" [selectedAviationEvent]="selectedAviationEvent"
                       [flyingClubs]="filteredFlyingClubs" [activeFlyingClub]="activeFlyingClub"
                       [onFlyingClubsTab]="selectedTab === flyingClubsTab"
                       [flightSchools]="filteredFlightSchools" [activeFlightSchool]="activeFlightSchool"
                       [onFlightSchoolsTab]="selectedTab === flightSchoolsTab"
                       [universities]="filteredUniversities" [activeUniversity]="activeUniversity"
                       [onUniversitiesTab]="selectedTab === universitiesTab"
                       [fbos]="filteredFbos" [activeFbo]="activeFbo"
                       [onFbosTab]="selectedTab === fbosTab"
                       [serviceRepairs]="filteredServiceRepairs" [activeServiceRepair]="activeServiceRepair"
                       [onServiceRepairsTab]="selectedTab === serviceRepairsTab"
                       [rentalSales]="filteredRentalSales" [activeRentalSales]="activeRentalSales"
                       [onRentalSalesTab]="selectedTab === rentalSalesTab"
                       [initialBounds]="query.bounds" [message]="mapMessage"
                       [showAirports]="eventsResultsListing.showAirports || (selectedTab !== aviationEventsTab && selectedTab !== flyingClubsTab && selectedTab !== flightSchoolsTab && selectedTab !== universitiesTab && selectedTab !== fbosTab && selectedTab !== serviceRepairsTab && selectedTab !== rentalSalesTab)"
                       [onEventsTab]="selectedTab === aviationEventsTab"
                       [aviationEventsFilter]="aviationEventFilter"
                       [initialLocation]="query.location"
                       (airportMouseEnter)="onAirportMarkerHover($event, true)"
                       (airportMouseLeave)="onAirportMarkerHover($event, false)"
                       (airportClick)="onAirportClick($event)"
                       (airportCardClose)="onCloseAirportCardWindow()"
                       (activityMouseEnter)="onActivityMarkerHover($event, true)"
                       (activityMouseLeave)="onActivityMarkerHover($event, false)"
                       (activityClick)="onActivityClick($event)"
                       (activityCardClose)="onCloseActivityWindow($event)"
                       (aviationEventMouseEnter)="onEventMarkerHover($event, true)"
                       (aviationEventMouseLeave)="onEventMarkerHover($event, false)"
                       (flyingClubMouseEnter)="onFlyingClubMarkerHover($event, true)"
                       (flyingClubMouseLeave)="onFlyingClubMarkerHover($event, false)"
                       (flyingClubClick)="onFlyingClubClick($event)"
                       (flightSchoolMouseEnter)="onFlightSchoolMarkerHover($event, true)"
                       (flightSchoolMouseLeave)="onFlightSchoolMarkerHover($event, false)"
                       (flightSchoolClick)="onFlightSchoolClick($event)"
                       (universityMouseEnter)="onUniversityMarkerHover($event, true)"
                       (universityMouseLeave)="onUniversityMarkerHover($event, false)"
                       (universityClick)="onUniversityClick($event)"
                       (fboMouseEnter)="onFboMarkerHover($event, true)"
                       (fboMouseLeave)="onFboMarkerHover($event, false)"
                       (fboClick)="onFboClick($event)"
                       (serviceRepairMouseEnter)="onServiceRepairMarkerHover($event, true)"
                       (serviceRepairMouseLeave)="onServiceRepairMarkerHover($event, false)"
                       (serviceRepairClick)="onServiceRepairClick($event)"
                       (rentalSalesMouseEnter)="onRentalSalesMarkerHover($event, true)"
                       (rentalSalesMouseLeave)="onRentalSalesMarkerHover($event, false)"
                       (rentalSalesClick)="onRentalSalesClick($event)">
      </app-results-map>
    </mat-sidenav-content>
  </mat-sidenav-container>
</div>

<div #backToSearchEl *ngIf="backToSearchVisible" class="search-page__back-to-search">
  <button type="button" (click)="backToSearch()" mat-fab class="search-page__back-to-search-btn" color="primary">
    <mat-icon>chevron_left</mat-icon>
  </button>
  <span (click)="backToSearch()" class="search-page__back-to-search-label">Back to Search</span>
</div>
